import React from "react";

export const SendIcon = ({
  strokeWidth = 3,
  size = "24",
  cursor = "pointer",
  color = "currentColor"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M8.09293 11.02L15.9415 3.17144M8.1883 11.2652L10.1528 16.3167C10.3258 16.7617 10.4123 16.9842 10.537 17.0491C10.6451 17.1054 10.7739 17.1055 10.882 17.0493C11.0068 16.9845 11.0936 16.7621 11.2671 16.3173L16.1933 3.69408C16.35 3.29255 16.4283 3.09178 16.3855 2.9635C16.3483 2.85208 16.2608 2.76465 16.1494 2.72743C16.0211 2.68458 15.8204 2.76292 15.4188 2.91962L2.79559 7.84576C2.35079 8.01934 2.12838 8.10613 2.06357 8.23089C2.00738 8.33904 2.00746 8.4678 2.06377 8.57588C2.12873 8.70056 2.35124 8.78709 2.79625 8.96015L7.84771 10.9246C7.93804 10.9597 7.98321 10.9773 8.02124 11.0044C8.05495 11.0285 8.08443 11.058 8.10847 11.0917C8.1356 11.1297 8.15317 11.1749 8.1883 11.2652Z"
        stroke="black"
        strokeWidth="1.34546"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
